module.exports = __webpack_public_path__ + "img/drone.d5f50c63.svg";